import PasswordReset from "./PasswordReset.vue";
export default PasswordReset;
